
import { useState, useEffect } from "react";
import Config from "../../Config";

import xset from "../../xset.png"


function FreeSettings(props)
{

    const [view, setView] = useState('inline');  //dialog

    const [tab, setTab] = useState(null);  //dialog


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const changeView = () => {
        if(view == 'inline')
        {
            setView('dlg');
        }else setView('inline');
    }

    const changeVal = (e) =>
    {
        var xname = e.target.name;
        var val = e.target.value;

        setTab( {...tab, [xname]:val  } );
    }


    if(props.userData.type != "DYREKTOR")
    {
        return null;
    }




    const getData = () => {
        
        props.mainView.setProgress(-2);

        var req = {
          
        };

        fetch( Config.url + '/rest_v1,pl_settings', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    setTab(res.result);
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const saveData = () => {
        
        props.mainView.setProgress(-2);

        var req = {
            termin_zgloszenia_nieobecnosci: tab.termin_zgloszenia_nieobecnosci,
            godzina_zgloszenia_nieobecnosci: tab.godzina_zgloszenia_nieobecnosci,
            nb_zgloszenie_weekend: tab.nb_zgloszenie_weekend,
        };

        fetch( Config.url + '/rest_v1,pl_up_settings', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    changeView();

                    if(res.status == 'OK') props.mainView.showDialog( "Sukces", "Zmiany zostały zapisane" , "ok" , null);
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    if(tab == null)
    {
        setTab([]);
        getData();
        return <div></div>
    }

    


    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }


    var dlg = <div className="dlg_window dlg_type_y shadowx">

            <div className="dlg_title">Ustawienia</div>
            

            <div className="dlg_content_x">
                
                    <form className="eForm bg_center">
                        
                               

                                    <div className="form_control">
                                        <div className="fieldName">Do kiedy rodzic musi zgłosić nieobecność:</div>
                                        <fieldset>
                                                <select autocomplete="off" name="termin_zgloszenia_nieobecnosci" defaultValue={tab.termin_zgloszenia_nieobecnosci} onChange={changeVal}>                                                   
                                                    <option value="1">Dzień przed</option>                                        
                                                    <option value="2" >W dniu nieobecności dziecka</option>
                                                </select>
                                        </fieldset>                                       
                                    </div>
 
                                    <div className="form_control">
                                        <div className="fieldName">Do godziny: </div>
                                        <fieldset>
                                                <input type="time"   name="godzina_zgloszenia_nieobecnosci" defaultValue={tab.godzina_zgloszenia_nieobecnosci} onChange={changeVal} />                                                
                                        </fieldset>                                       
                                    </div>

                                    <br/>

                                    
                                    <div className="form_control">
                                        <div className="fieldName">Weekend:</div>
                                        <fieldset>
                                                <select autocomplete="off" name="nb_zgloszenie_weekend" defaultValue={tab.nb_zgloszenie_weekend} onChange={changeVal}>                                                   
                                                    <option value="0">---</option>                                        
                                                    <option value="1" >Sobota, niedziela - zawsze po czasie</option>
                                                    <option value="A" >Sobota  do 10:00, niedziela zawsze po czasie</option>
                                                    <option value="B" >Sobota  do 11:00, niedziela zawsze po czasie</option>
                                                    <option value="C" >Sobota  do 12:00, niedziela zawsze po czasie</option>
                                                    <option value="D" >Śniadania I/II do 15:00 PT,  Obiad do 9:00 w dniu nieobecności</option>
                                                </select>
                                        </fieldset>                                       
                                    </div>


                    </form>

            </div>



            <div className="dlg_btn">
                    <span className="btn" onClick={saveData}>Zapisz</span>
                    &nbsp;
                    <span className="btn" onClick={changeView}>Zamknij</span>
            </div>
            <br/>

    </div>

    if(view == 'inline') 
        {
            return (
                <div className="q_bottom" onClick={changeView} >
                    <div className="q_settings link_color" >               
                        ustawienia nieobecności                        
                    </div>
                </div>       
            )
        }


     if(dlg != null)   return dlg;


    return (
        <div className="q_bottom" >
            <div className="q_settings link_color" >               
                ustawienia nieobecności 
                {dlg}       
            </div>
        </div>       
    )
}


export default FreeSettings;